var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill"},[_c('div',{attrs:{"id":"skillName"}},[_c('p',[_vm._v(_vm._s(_vm.currentSkill.name))])]),_c('circle-progress-bar',{attrs:{"percentage":_vm.currentSkill.pers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }